import { Text } from '@hub/text';
import React from 'react';
import { jsxs as _jsxs } from "react/jsx-runtime";
const pagination = (page, limit, total) => {
  const start = page * limit + 1;
  const end = Math.min((page + 1) * limit, total);
  return total === 0 ? '0' : "".concat(start, " \u2013 ").concat(end, " of ").concat(total);
};
export const PaginationSummary = _ref => {
  let {
    total,
    limit,
    page,
    suffix,
    sx
  } = _ref;
  return /*#__PURE__*/_jsxs(Text, {
    sx: sx,
    "data-id": "pagination-summary_index_PaginationSummary_Text",
    children: [pagination(page, limit, total), suffix]
  });
};